import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  Modal,
  Row,
  Col,
  Checkbox,
  Button,
  DatePicker,
  Form,
  Select,
  Radio,
  Space,
  Input,
  message,
} from 'antd';
import { Option } from 'antd/lib/mentions';
import '../../styles/index.scss';
import moment from 'moment';
import { getNumberWithSuffix } from '../../utils/task.utils';
import { space } from '../../configs/designTokens';

export const TaskDatePickerModal = ({ visible, setVisible, onClose, currentDueDateConfig, disabledDates = true, slaDays = 0, slaRequestType = '' }) => {
  const [isRecurring, setIsRecurring] = useState(false);
  const [recurrenceType, setRecurrenceType] = useState('');
  const [monthlyType, setMonthlyType] = useState('DAY_OF_MONTH');
  const [isSelecting, setIsSelecting] = useState(false);

  const [form] = Form.useForm();

  const handleDateOk = () => {
    try {
      const values = form.getFieldsValue();

      setVisible(false);
      message.destroy();
      onClose(form.getFieldsValue());
    } catch (error) {
      message.error('Error occurred while validating date:', error);
    }
  };

  useEffect(() => {
    if (currentDueDateConfig) {
      console.log('currentDueDateConfig', currentDueDateConfig);
      form.setFieldsValue({
        dueDate: moment(currentDueDateConfig.dueDate),
      });

      if (currentDueDateConfig.recurring) {
        form.setFieldsValue({
          recurring: currentDueDateConfig.recurring || false,
          recurrenceType: currentDueDateConfig.recurrenceType,
        });

        switch (currentDueDateConfig.recurrenceType) {
          case 'WEEKLY':
            form.setFieldsValue({
              weeklyDays: currentDueDateConfig.weeklyDays,
            });
            break;

          case 'BIWEEKLY':
            form.setFieldsValue({
              weeklyDays: currentDueDateConfig.weeklyDays,
            });
            break;

          case 'MONTHLY':
            form.setFieldsValue({
              monthlyType: currentDueDateConfig.monthlyType,
              dayOfMonth: currentDueDateConfig.dayOfMonth,
              dayOfWeek: currentDueDateConfig.dayOfWeek,
              dateOfMonth: currentDueDateConfig.dateOfMonth,
            });
            setMonthlyType(currentDueDateConfig.monthlyType);

            break;
          case 'YEARLY':
            form.setFieldsValue({
              yearlyMonth: currentDueDateConfig.yearlyMonth,
              yearlyDate: currentDueDateConfig.yearlyDate,
            });
            break;

          default:
            break;
        }
        setRecurrenceType(currentDueDateConfig.recurrenceType);
        setIsRecurring(currentDueDateConfig.recurring);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDueDateConfig]);

  return (
    <>
      <Modal
        closable={false}
        open={visible}
        width={isRecurring ? 500 : 300}
        onCancel={() => setVisible(false)}
        footer={null}
        className="task-date-picker-modal"
        bodyStyle={{ padding: space[0], overflow: 'visible' }}
      >
        <Form
          form={form}
          initialValues={{
            recurring: false,
            dueDate: moment(),
          }}
        >
          <div className="task-date-picker-modal__container">
            <div className="task-date-picker-modal__content" style={{ width: isRecurring ? 300 : '100%' }}>
              <div className="task-date-picker-modal__picker-wrapper">
                <Form.Item name="dueDate" noStyle>
                  <DatePicker
                    open={visible}
                    onChange={() => {
                      setIsSelecting(true);
                      setTimeout(() => setIsSelecting(false), 100);
                    }}
                    onOpenChange={(open) => {
                      if (!open && !isSelecting) {
                        setVisible(false);
                      }
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="task-date-picker"
                    disabledDate={disabledDates ? (current) => {
                      const today = moment().startOf('day');
                      return current && current.isBefore(today, 'day');
                    } : null}
                    dateRender={slaDays > 0 ? (current) => {
                      const today = moment().startOf('day');
                      const slaEnd = moment().startOf('day').add(slaDays, 'days');
                      const isInRange = current.isSameOrAfter(today, 'day') && current.isSameOrBefore(slaEnd, 'day');
                      const isStart = current.isSame(today, 'day');
                      const isEnd = current.isSame(slaEnd, 'day');
                      const classes = [
                        'ant-picker-cell-inner',
                        isInRange && 'sla-in-range',
                        isStart && 'sla-range-start',
                        isEnd && 'sla-range-end',
                      ].filter(Boolean).join(' ');
                      return <div className={classes}>{current.date()}</div>;
                    } : undefined}
                  />
                </Form.Item>
              </div>
              {slaDays > 0 && (
                <div className="task-date-picker-modal__sla-label">
                  <span className="task-date-picker-modal__sla-label-title">
                    SLA: {slaRequestType} &mdash; {slaDays} {slaDays === 1 ? 'day' : 'days'}
                  </span>
                  <span className="task-date-picker-modal__sla-label-date">
                    Recommended by: {moment().add(slaDays, 'days').format('MMM D, YYYY')}
                  </span>
                </div>
              )}
              <div
                className="task-date-picker-modal__footer task-date-picker-modal__footer--between"
                onMouseDown={() => setIsSelecting(true)}
                onMouseUp={() => setIsSelecting(false)}
              >
                <Form.Item name="recurring" valuePropName="checked">
                  <Checkbox
                    onChange={(e) => {
                      const value = e.target.checked;
                      setIsRecurring(value);
                      if (value) {
                        form.setFieldsValue({ recurrenceType: 'DAILY' });
                      } else {
                        form.setFieldsValue({ recurrenceType: '' });
                      }
                    }}
                  >
                    Recurring
                  </Checkbox>
                </Form.Item>
                <Button type="link" onClick={handleDateOk}>
                  Update
                </Button>
              </div>
            </div>

            {/* Recurring config */}
            {isRecurring && (
              <div
                className="task-date-picker-modal__recurring"
                onMouseDown={() => setIsSelecting(true)}
                onMouseUp={() => setIsSelecting(false)}
              >
                <span className="task-date-picker-modal__recurring-title">Repeats</span>
                  <Row style={{ marginTop: space[5], marginBottom: space[4] }}>
                    <Form.Item name="recurrenceType" noStyle>
                      <Select
                        style={{ width: 150 }}
                        onMouseDown={() => setIsSelecting(true)}
                        onMouseUp={() => setIsSelecting(false)}
                        onChange={(value) => {
                          setRecurrenceType(value);
                          // Reset dateOfMonth, dayOfMonth, dayOfWeek, yearlyMonth, yearlyDate
                          form.setFieldsValue({
                            dateOfMonth: null,
                            dayOfMonth: null,
                            dayOfWeek: null,
                            yearlyMonth: null,
                            yearlyDate: null,
                          });

                          switch (value) {
                            case 'MONTHLY':
                              form.setFieldsValue({
                                monthlyType: 'DAY_OF_MONTH',
                                dayOfMonth: 1,
                                dayOfWeek: 'MONDAY',
                              });
                              break;
                            case 'YEARLY':
                              form.setFieldsValue({
                                yearlyMonth: 'JANUARY',
                                yearlyDate: 1,
                              });
                              break;
                            default:
                              break;
                          }
                        }}
                      >
                        <Option value="DAILY">Daily</Option>
                        <Option value="WEEKLY">Weekly</Option>
                        <Option value="BIWEEKLY">Bi-Weekly</Option>
                        <Option value="MONTHLY">Monthly</Option>
                        <Option value="YEARLY">Yearly</Option>
                      </Select>
                    </Form.Item>
                  </Row>
                  {recurrenceType === 'WEEKLY' && (
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                      <div>Repeat weekly on</div>
                      <Form.Item name="weeklyDays" noStyle>
                        <Checkbox.Group
                          options={[
                            { label: 'Sunday', value: 'SUNDAY' },
                            { label: 'Monday', value: 'MONDAY' },
                            { label: 'Tuesday', value: 'TUESDAY' },
                            { label: 'Wednesday', value: 'WEDNESDAY' },
                            { label: 'Thursday', value: 'THURSDAY' },
                            { label: 'Friday', value: 'FRIDAY' },
                            { label: 'Saturday', value: 'SATURDAY' },
                          ]}
                        ></Checkbox.Group>
                      </Form.Item>
                    </Space>
                  )}
                  {recurrenceType === 'MONTHLY' && (
                    <>
                      <Form.Item name="monthlyType" noStyle>
                        <Input type="hidden" />
                      </Form.Item>

                      <Row>
                        <Col span={24}>
                          <span>Repeat monthly on</span>
                          {/* Radio for Day of Month */}
                          <Radio
                            checked={monthlyType === 'DAY_OF_MONTH'}
                            onChange={() => {
                              setMonthlyType('DAY_OF_MONTH');
                              form.setFieldsValue({
                                monthlyType: 'DAY_OF_MONTH',
                                dayOfMonth: 1,
                                dayOfWeek: 'Monday',
                                dateOfMonth: null,
                              });
                            }}
                          >
                            Day of Month
                          </Radio>
                          <Row gutter={16} style={{ marginTop: space[2.5] }}>
                            <Col span={12}>
                              <Form.Item name="dayOfMonth" noStyle>
                                <Select
                                  style={{ width: '100%' }}
                                  disabled={form.getFieldValue('monthlyType') !== 'DAY_OF_MONTH'}
                                >
                                  <Option value={1}>1st</Option>
                                  <Option value={2}>2nd</Option>
                                  <Option value={3}>3rd</Option>
                                  <Option value={4}>4th</Option>
                                  <Option value={5}>5th</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item name="dayOfWeek" noStyle>
                                <Select disabled={monthlyType !== 'DAY_OF_MONTH'}>
                                  <Option value="SUNDAY">Sun</Option>
                                  <Option value="MONDAY">Mon</Option>
                                  <Option value="TUESDAY">Tue</Option>
                                  <Option value="WEDNESDAY">Wed</Option>
                                  <Option value="THURSDAY">Thurs</Option>
                                  <Option value="FRIDAY">Fri</Option>
                                  <Option value="SATURDAY">Sat</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row style={{ marginTop: space[5] }}>
                            <Col span={24}>
                              <Radio
                                checked={monthlyType === 'DATE_OF_MONTH'}
                                onChange={() => {
                                  setMonthlyType('DATE_OF_MONTH');
                                  form.setFieldsValue({
                                    monthlyType: 'DATE_OF_MONTH',
                                    dateOfMonth: 15,
                                    dayOfMonth: null,
                                    dayOfWeek: null,
                                  });
                                }}
                              >
                                Date of Month
                              </Radio>
                            </Col>
                          </Row>

                          <Row style={{ marginTop: space[2.5] }}>
                            <Form.Item name="dateOfMonth" noStyle>
                              <Select
                                style={{ width: '50%' }}
                                disabled={monthlyType !== 'DATE_OF_MONTH'}
                              >
                                {[...Array(31)].map((_, i) => (
                                  <Option key={i} value={i + 1}>
                                    {getNumberWithSuffix(i + 1)}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                  {recurrenceType === 'YEARLY' && (
                    <Row>
                      <Col span={24}>
                        <span>Repeat yearly on</span>
                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item name="yearlyMonth" noStyle>
                              <Select style={{ width: '100%' }}>
                                <Option value="JANUARY">Jan</Option>
                                <Option value="FEBRUARY">Feb</Option>
                                <Option value="MARCH">Mar</Option>
                                <Option value="APRIL">Apr</Option>
                                <Option value="MAY">May</Option>
                                <Option value="JUNE">Jun</Option>
                                <Option value="JULY">Jul</Option>
                                <Option value="AUGUST">Aug</Option>
                                <Option value="SEPTEMBER">Sep</Option>
                                <Option value="OCTOBER">Oct</Option>
                                <Option value="NOVEMBER">Nov</Option>
                                <Option value="DECEMBER">Dec</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item name="yearlyDate" noStyle>
                              <Select style={{ width: '100' }}>
                                {[...Array(31)].map((_, i) => (
                                  <Option key={i} value={i + 1}>
                                    {getNumberWithSuffix(i + 1)}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </div>
            )}
          </div>
        </Form>
      </Modal>
    </>
  );
};
